import { useEffect, useState } from "react"
import { Input, Button, Table, Space, Popconfirm, Select, DatePicker, Modal, message } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    user_name: string | undefined,
    phone: string | undefined,
    supply_id: string | undefined,
    order_code: string | undefined,
    order_status: number | undefined,
    date: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        user_name: undefined,
        phone: undefined,
        supply_id: undefined,
        order_code: undefined,
        order_status: undefined,
        date: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 列表Loading
    const [loading, setLoading] = useState<boolean>(false)

    const [supplyOptions, setSupplyNameOptions] = useState<{ "id": string, "supply_name": string }[]>([])
    const [currentRecord, setCurrentRecord] = useState<any>()
    const [detailVisible, setDetailVisible] = useState<boolean>(false)

    const [orderDetail, setOrderDetail] = useState<any>()
    const [remark, setRemark] = useState<string>('')

    useEffect(() => {
        baseAxiosNoInfo('/global/supply/list', { params: {} }).then((res: any) => {
            res && setSupplyNameOptions(res)
        })
    }, [])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const showDetailVisible = (record: any) => {
        setRemark('')
        setCurrentRecord(record)

        if (record.is_shopping_cart === 1) {
            baseAxiosNoInfo('/mall_center/order/shopping_cart_detail', {
                params: {
                    order_id: record.id
                }

            }).then(res => {
                res && setOrderDetail(res)
            })
        }

        setDetailVisible(true)
    }

    let ModalFooterButtons = () => {
        if (currentRecord && currentRecord.order_status === 2) {
            // 发货
            return <Space>
                <Button onClick={() => { setDetailVisible(false) }}>取消</Button>
                <Button type="primary" onClick={handleSend}>确定</Button>
            </Space>

        } if (currentRecord && currentRecord.order_status !== 2) {
            // 非发货状态
            return <Button onClick={() => { setDetailVisible(false) }}>取消</Button>
        }

        return null
    }

    const handleSend = () => {
        if (remark.length > 0) {
            baseAxiosComplete.post('/mall_center/order/delivery', {
                id: currentRecord.id,
                remark: remark

            }).then(res => {
                if (res.status === 0) {
                    resetForm()
                    setDetailVisible(false)
                }
            })

        } else {
            message.error('输入备注')
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.order_start_date = params.date[0].format('YYYY-MM-DD')
            params.order_end_date = params.date[1].format('YYYY-MM-DD')
            delete params.date
        }

        axiosTable.get('/mall_center/order/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const exportExcel = () => {
        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.order_start_date = params.date[0].format('YYYY-MM-DD')
            params.order_end_date = params.date[1].format('YYYY-MM-DD')
            delete params.date
        }

        baseAxiosComplete('/mall_center/order/excel', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 商城中心 -> 商品管理 -> 商品订单管理 */}
        <BreadCrumb position={['商城中心', '商品订单管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Input style={{ width: '150px', marginRight: 5, marginBottom: 12 }} placeholder="会员昵称" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'user_name') }} value={fetchOtherParams.user_name} />
                <Input style={{ width: '150px', marginRight: 5, marginBottom: 12 }} placeholder="会员手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'phone') }} value={fetchOtherParams.phone} />

                <Select style={{ width: '180px', marginRight: 5, marginBottom: 12 }} placeholder="供应商" value={fetchOtherParams.supply_id} onChange={(v: string) => { handleChange(v, 'supply_id') }}>
                    {supplyOptions.map(el => <Option value={el.id} key={el.id}>{el.supply_name}</Option>)}
                </Select>

                <Input style={{ width: '180px', marginRight: 5, marginBottom: 12 }} placeholder="订单编号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'order_code') }} value={fetchOtherParams.order_code} />
                <Select style={{ width: '180px', marginRight: 5, marginBottom: 12 }} placeholder="订单状态" value={fetchOtherParams.order_status} onChange={(v: number) => { handleChange(v, 'order_status') }}>
                    <Option value={1} key={1}>待付款</Option>
                    <Option value={2} key={2}>待发货</Option>
                    <Option value={3} key={3}>已发货</Option>
                    <Option value={4} key={4}>已收货</Option>
                    <Option value={5} key={5}>已取消</Option>
                </Select>

                <RangePicker style={{ marginRight: 5, marginBottom: 12 }} value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button className="search-btn" style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={exportExcel}>导出</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="会员昵称" dataIndex="user_name" key="user_name" />
                <Column title="会员手机" dataIndex="phone" key="phone" />

                <Column title="订单编号" dataIndex="order_code" key="order_code" />
                <Column title="订单状态" dataIndex="order_status" key="order_status" render={(v: any) => {
                    switch (v) {
                        case 1:
                            return '待付款'
                        case 2:
                            return '待发货'
                        case 3:
                            return '已发货'
                        case 4:
                            return '已收货'
                        case 5:
                            return '已取消'
                    }
                }} />
                <Column title="是否购物车订单" dataIndex="is_shopping_cart" key="is_shopping_cart" render={(v: number) => v === 1 ? '是' : '否'} />

                <Column title="订单供应商" render={(v: any) => { return v.is_shopping_cart === 1 ? '' : v.supply_name }} />
                <Column title="订单商品" render={(v: any) => {
                    return v.is_shopping_cart === 1 ? <Button size="small" onClick={() => { showDetailVisible(v) }}>查看详情</Button> : v.goods_name
                }} />
                <Column title="订单售价" render={(v: any) => { return v.is_shopping_cart === 1 ? '' : v.sale_price }} />
                <Column title="订单数量" render={(v: any) => { return v.is_shopping_cart === 1 ? '' : v.num }} />
                <Column title="订单总金额" dataIndex="total_amount" key="total_amount" />
                <Column title="优惠金额" dataIndex="deduct_amount" key="deduct_amount" />
                <Column title="实付金额" dataIndex="final_pay_amount" key="final_pay_amount" />
                <Column title="收货人" dataIndex="delivery_name" key="delivery_name" />
                <Column title="收货人手机号" dataIndex="delivery_phone" key="delivery_phone" />
                <Column title="收货地址" dataIndex="delivery_address" key="delivery_address" />
                <Column title="发货备注" dataIndex="remark" key="remark" />
                <Column title="下单时间" dataIndex="order_time" key="order_time" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            {record.order_status === 1 && <Popconfirm
                                title="取消订单?"
                                onConfirm={() => {
                                    baseAxiosComplete.post('/mall_center/order/cancel', {
                                        id: record.id
                                    }).then(res => {
                                        if (res.status === 0) { resetForm() }
                                    })
                                }}
                                okText="是"
                                cancelText="否"
                            >
                                <Button size="small">取消订单</Button>
                            </Popconfirm>}

                            {record.order_status === 2 && <Button size="small" onClick={() => { showDetailVisible(record) }}>发货</Button>}

                            {record.order_status === 3 && <Popconfirm
                                title="确认收货?"
                                onConfirm={() => {
                                    baseAxiosComplete.post('/mall_center/order/confirm', {
                                        id: record.id
                                    }).then(res => {
                                        if (res.status === 0) { resetForm() }
                                    })
                                }}
                                okText="是"
                                cancelText="否"
                            >
                                <Button size="small">确认收货</Button>
                            </Popconfirm>}
                        </Space>
                    )}
                />
            </Table>
        </div>

        {/* 订单详情 */}
        <Modal width="1000px" visible={detailVisible} title="订单详情" onCancel={() => { setDetailVisible(false) }} footer={<ModalFooterButtons />} >
            <Table dataSource={[currentRecord]} rowKey="id" pagination={false}>
                <Column title="会员昵称" dataIndex="user_name" key="user_name" />
                <Column title="会员手机" dataIndex="phone" key="phone" />

                <Column title="下单时间" dataIndex="order_time" key="order_time" />
                <Column title="订单状态" dataIndex="order_status" key="order_status" render={(v: any) => {
                    switch (v) {
                        case 1:
                            return '待付款'
                        case 2:
                            return '待发货'
                        case 3:
                            return '已发货'
                        case 4:
                            return '已收货'
                        case 5:
                            return '已取消'
                    }
                }} />
                <Column title="商品数量" dataIndex="num" key="num" />
                <Column title="订单总金额" dataIndex="total_amount" key="total_amount" />
                <Column title="优惠金额" dataIndex="deduct_amount" key="deduct_amount" />
                <Column title="实付金额" dataIndex="final_pay_amount" key="final_pay_amount" />
            </Table>

            {orderDetail && currentRecord.is_shopping_cart === 1 && <Table style={{ marginTop: 18 }} dataSource={orderDetail} rowKey="id" pagination={false}>
                <Column title="供应商名称" dataIndex="supply_name" key="supply_name" />
                <Column title="商品名称" dataIndex="goods_name" key="goods_name" />
                <Column title="商品单价" dataIndex="sale_price" key="sale_price" />
                <Column title="商品数量" dataIndex="num" key="num" />
                <Column title="商品总金额" dataIndex="total_amount" key="total_amount" />
            </Table>}

            {currentRecord && currentRecord.order_status === 2 && <div style={{ marginTop: 10 }}>
                <Input placeholder="备注，可将快递单号写在备注里" value={remark} onChange={(e) => { setRemark(e.target.value) }} />
            </div>}
        </Modal>
    </div>)
}